export const UserAvailableActionsTypes = {
  ARCHIVE   :'ARCHIVE',
  UNARCHIVE :'UNARCHIVE',
  LOCKED    :'LOCKED',
  UNLOCK    :'UNLOCK'
};
